import { NotificationParser } from "@app/wapps/notification/notification.parser";
import { Notification } from "@app/wapps/notification/notification.model";
import { Injector } from "@angular/core";
import { UserNotification } from "@api/core.models";
import { format } from "date-fns";
import { NOTIFICATION_TIME_FORMAT, PT_BR_DATE_LOCALE } from "@ui/date-formats";

export class AttendanceReportExportNotificationParser extends NotificationParser {
    static Type = "Wapps.Report.Attendance.ExportAttendanceReport.Notifications.AttendanceReportExportNotificationData";

    constructor(injector: Injector) {
        super(injector);
    }

    parse(userNotification: UserNotification): Notification {
        let id = userNotification.id;
        let icon = "file_download";
        let title = this.isAppointmentReport(userNotification.notification.data)
            ? this.l("Seu relatório de agendamentos está pronto")
            : this.l("Seu relatório de atendimentos está pronto");
        const subtitle = format(new Date(userNotification.notification.creationTime), NOTIFICATION_TIME_FORMAT, {
            locale: PT_BR_DATE_LOCALE,
        });
        return new Notification(id, icon, title, subtitle, userNotification);
    }

    private isAppointmentReport(data: any): boolean {
        let reportType = data?.properties?.reportType ?? data?.reportType;
        return reportType === "Appointment";
    }

    static getDownloadUrl(notification: Notification): string {
        let data: any = notification.userNotification.notification.data;
        return data?.properties?.downloadUrl ?? data?.downloadUrl;
    }

    open(notification: Notification) {
        let downloadUrl = AttendanceReportExportNotificationParser.getDownloadUrl(notification);
        if (downloadUrl) {
            window.open(downloadUrl, "_blank");
        }
    }
}
